import axiosTokenInstance from 'services/api/backoffice';
import { OPENPAY, OPENPAY_ERROR } from '_models/redux/types';

// Action function
export const openPayAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`/api/reports/v2/transactions-openpay`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: OPENPAY,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: OPENPAY_ERROR,
        payload: e || {},
      });
    }
  };
